import { mainCategories } from './Categories';
import { GuideMenuItems } from './Guide';
import { Route } from './Route';

export interface MenuItem {
  title: string;
  subTitle: string;
  items: {
    title: string;
    route: Route;
  }[];
}

export const GuideMenu: MenuItem['items'] = [
  {
    title: 'ご利用ガイド',
    route: {
      route: 'guides',
    },
  },
  ...GuideMenuItems.map((item) => ({
    title: item.title,
    route: item.route,
  })),
];

export const Menu: MenuItem[][] = [
  [
    {
      title: '商品カテゴリー',
      subTitle: 'PRODUCTS',
      items: [
        {
          title: '全てのカテゴリー',
          route: {
            route: 'categories',
          },
        },
        ...mainCategories.map((category) => ({
          title: category,
          route: { route: 'category', handle: category } as Route,
        })),
      ],
    },
  ],
  [
    {
      title: 'ご利用案内',
      subTitle: 'GUIDE',
      items: GuideMenu,
    },
  ],
  [
    {
      title: 'コンテンツ',
      subTitle: 'CONTENT',
      items: [
        {
          title: '特集ページ',
          route: {
            route: 'features',
          },
        },
        {
          title: 'お知らせ',
          route: {
            route: 'news',
          },
        },
      ],
    },
    {
      title: '各種情報',
      subTitle: 'INFORMATION',
      items: [
        {
          title: '特定商取引法に基づく表記',
          route: {
            route: 'legal',
          },
        },
        {
          title: 'プライバシーポリシー',
          route: {
            route: 'privacy',
          },
        },
        {
          title: 'ご利用規約',
          route: {
            route: 'terms',
          },
        },
        {
          title: '＆COCOについて',
          route: {
            route: 'about',
          },
        },
        {
          title: '運営会社',
          route: {
            route: 'url',
            url: 'https://cocopet.jp/company',
          },
        },
      ],
    },
  ],
];
